function toElements(html: string): NodeList {
    // Create element (template)
    const elTemplate = document.createElement('template');
    // Never return a text node of whitespace as the result
    elTemplate.innerHTML = html.trim();

    // Return
    return elTemplate.content.childNodes;
}

// ----------------------------------------------------------------------------

(String as any).prototype.toElements = function (): NodeList {
    return toElements(this);
};

// ----------------------------------------------------------------------------

export default toElements;
